var api = require("!../../../../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ref--5-oneOf-7-1!../../../../../../../../../../node_modules/less-loader/dist/cjs.js??ref--5-oneOf-7-2!./viewSelector.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};